import { createPortal } from "react-dom";
import { usePortal } from "../../hooks/usePortal";

export const PageButtons = ({ children }: any) => {
  const target = usePortal("page-buttons");
  if (!target) return null;
  return createPortal(children, target);
};
